import { LAYOUTS, } from '@voltmoney/types';
import { WIDGET } from '@voltmoney/schema';
import { ROUTE } from '../../routes';
import { openContactUsCard, retryUserContextAPI } from './actions';
import { ACTION } from "./types";
const template = (height) => ({
    layout: {
        id: ROUTE.USER_CONTEXT_500,
        type: LAYOUTS.LIST,
        widgets: [
            { id: "userContext500Page", type: WIDGET.USER_CONTEXT_500 }
        ],
    },
    datastore: {
        userContext500Page: {
            height: height,
            contactUsAction: {
                type: ACTION.CONTACT_US_CARD,
                routeId: ROUTE.USER_CONTEXT_500,
                payload: {}
            },
            retryAPI: {
                type: ACTION.RETRY_API,
                routeId: ROUTE.USER_CONTEXT_500,
                payload: {}
            }
        }
    },
});
export const userContext500MF = {
    onLoad: async ({ getHeight }) => {
        return Promise.resolve(template(getHeight()));
    },
    actions: {
        [ACTION.CONTACT_US_CARD]: openContactUsCard,
        [ACTION.RETRY_API]: retryUserContextAPI,
    }
};
